// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__fCjHZ","rightAdornment":"Header_rightAdornment__yYbug"};